<template>
  <q-page padding>
    <q-toolbar class="q-px-md">
      <q-toolbar-title class="text-weight-medium"> Página Inicial </q-toolbar-title>
      <!-- <q-toggle v-model="edit" :label="$t('edit')" /> -->

      <div>
        <!-- <div class="row justify-end">
          <q-btn
            flat
            dense
            icon-right="mdi-download-outline"
            class="q-mb-sm"
            color="primary"
            label="Baixar PDF"
            no-caps
          />
        </div> -->
        <div class="row">
          <!-- <q-checkbox
            label="Ignorar campanhas de teste"
            true-value="1"
            false-value="0"
            v-model="ignoreTestCampaigns"
            class="q-mr-sm"
          /> -->
          <date-input
            buttons
            class="q-mr-sm"
            dense
            outlined
            label="Período"
            :v-model="period"
            @update="
              (val) => {
                period = val;
              }
            "
            today-btn
            range
            label-color="primary"
          />
          <q-btn-dropdown
            no-caps
            outline
            class="q-mr-sm"
            content-style="width: 380px"
            :menu-offset="[0, 10]"
            label="Filtros"
          >
            <q-list separator>
              <div v-for="(filter, index) in Object.values(filters)" :key="index">
                <q-item clickable @click="filter.editing = !filter.editing" class="q-pa-md">
                  <q-item-section>
                    <div :class="isFilterActive(filter) ? 'text-bold' : ''">
                      {{ isFilterActive(filter) ? '->' : '' }}
                      {{ filter.label }}
                    </div>
                  </q-item-section>
                  <q-item-section side>
                    <q-icon :name="filter.editing ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" />
                  </q-item-section>
                </q-item>
                <div class="col-12 q-px-md q-py-sm" v-if="filter.editing">
                  <q-select
                    v-model="filter.value"
                    :options="filter.name == 'statuses' ? filter.options : filter.optionsFiltered"
                    map-options
                    emit-value
                    :label="filter.label"
                    :option-label="filter.option_label"
                    :option-value="filter.option_value"
                    outlined
                    clearable
                    use-input
                    :multiple="filter.name !== 'channels'"
                    :use-chips="filter.name !== 'channels'"
                    @filter="(val, update) => update(selectFilter(val, index, filter.option_label))"
                    @clear="filter.value = filter.name !== 'channels' ? [] : ''"
                  />
                </div>
              </div>
            </q-list>

            <div class="flex justify-center q-pa-md q-mt-sm">
              <q-btn
                label="Remover Filtros"
                unelevated
                outline
                color="primary"
                style="width: 160px"
                @click="resetFilters"
                no-caps
              />
            </div>
          </q-btn-dropdown>

          <q-btn color="primary" padding="7px 7px" unelevated icon="search" dense @click="getDashboard" />
        </div>
      </div>
    </q-toolbar>
    <!-- <dashboard-main :editGrid="edit" /> -->
    <dashboard-affiliate :summary="summary" :campaign-metrics="campaignMetrics" :exclusive-campaigns="exclusiveCampaigns" />
  </q-page>
</template>

<style></style>

<script>
import DashboardAffiliate from '@/components/dashboard/DashboardAffiliate.vue';
import DateInput from '@/widgets/inputsGlobal/DateInput.vue';
import AdvertiserService from '@/services/AdvertiserService.js';
import AffiliateService from '@/services/AffiliateService.js';

export default {
  name: 'PageDashboard',
  components: { DashboardAffiliate, DateInput },
  mixins: [AdvertiserService, AffiliateService],
  mounted() {
    this.retrieveSelectOptions();
    this.getDashboard();
  },
  created() {
    this.period = `${this.$moment().subtract(7, 'days').format('L')} - ${this.$moment().format('L')}`;
  },

  data() {
    return {
      //   edit: false
      period: '',
      //   ignoreTestCampaigns: '1',
      summary: {
        conversionValue: 0,
        commissionValue: 0,
        conversionAmount: 0
      },
      campaignMetrics: {
        type: Array,
        default: () => []
      },
      exclusiveCampaigns: {
        type: Array,
        default: () => []
      },

      filters: {
        status: {
          label: 'Status',
          name: 'statuses',
          value: [],
          editing: false,
          options: [
            { label: 'Aprovado', value: 2 },
            { label: 'Pendente', value: 1 },
            { label: 'Recusado', value: 0 }
          ]
        },
        campaign: {
          label: 'Campanha',
          name: 'campaigns',
          value: [],
          editing: false,
          options: [],
          optionsFiltered: [],
          option_label: 'campaign_name',
          option_value: 'campaign_id'
        },
        channel: {
          label: 'Canal',
          name: 'channels',
          value: '',
          editing: false,
          options: [],
          optionsFiltered: [],
          option_label: 'name',
          option_value: 'id'
        }
      }
    };
  },

  methods: {
    isFilterActive(filter) {
      if (Array.isArray(filter.value)) {
        return filter.value.length > 0;
      }
      return !!filter.value;
    },

    periodString() {
      var [startDate, endDate] = this.period.split(' - ');
      return `start_date%3D${this.formatToEn(startDate)}%26end_date%3D${this.formatToEn(endDate)}`;
    },

    async getDashboard() {
      this.params = `${this.periodString()}`;

      if (this.filters.status.value.length) {
        this.params += `%26validation_status%3D${this.filters.status.value.join('%2C')}`;
      }
      if (this.filters.campaign.value.length) {
        this.params += `%26campaign_id%3D${this.filters.campaign.value.join('%2C')}`;
      }
      if (this.filters.channel.value) {
        this.params += `%26site_id%3D${this.filters.channel.value}`;
      }

      try {
        this.onLoading(true);

        const [summaryRes, metricsRes, exclusiveRes] = await Promise.all([
          this.getDashboardSummaryAffiliate(this.params),
          this.getDashboardCampaignsAffiliate(this.params),
          this.getDashboardExclusiveCampaigns()
        ]);

        const { data: summary } = summaryRes;
        this.summary = {
          conversionValue: summary.transaction_amount,
          commissionValue: summary.affiliate_commission_cost,
          conversionAmount: summary.quantity_transactions
        };

        this.campaignMetrics = metricsRes.data;
        this.exclusiveCampaigns = exclusiveRes.data;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async retrieveSelectOptions() {
      try {
        this.onLoading(true);
        const options = await Promise.all([
          this.getCampaignListAffiliate(this.user.affiliate_id),
          this.getAffiliateSiteActiveListByID(this.user.affiliate_id)
        ]);
        this.filters['campaign'].options = this.filters['campaign'].optionsFiltered = options[0].data;
        this.filters['channel'].options = this.filters['channel'].optionsFiltered = options[1].data;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    selectFilter(val, index, prop = null) {
      const needle = val.toLocaleLowerCase();
      const filters = Object.values(this.filters);
      filters[index].optionsFiltered = needle
        ? filters[index].options.filter((v) =>
            prop ? v[prop].toLocaleLowerCase().includes(needle) : v.toLocaleLowerCase().includes(needle)
          )
        : filters[index].options;
    },

    resetFilters() {
      let reload = false;
      Object.keys(this.filters).forEach((key) => {
        if (this.isFilterActive(this.filters[key])) {
          reload = true;
        }
        if (Array.isArray(this.filters[key].value)) {
          this.filters[key].value = [];
        } else {
          this.filters[key].value = '';
        }
      });
      if (reload) this.getDashboard();
      this.filters.status.editing = false;
      this.filters.campaign.editing = false;
      this.filters.channel.editing = false;
    }
  }
};
</script>
